import { render, staticRenderFns } from "./uv-index-legenda.vue?vue&type=template&id=1c4f19ec&"
import script from "./uv-index-legenda.vue?vue&type=script&lang=js&"
export * from "./uv-index-legenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports